import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=7134feaf&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=7134feaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7134feaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7134feaf')) {
      api.createRecord('7134feaf', component.options)
    } else {
      api.reload('7134feaf', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=7134feaf&scoped=true&", function () {
      api.rerender('7134feaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28dA5JMfFc1wJ/JS/comp/Voucher.vue"
export default component.exports